import DashView from './components/Dash.vue'
import LoginView from './components/Login.vue'
import NotFoundView from './components/404.vue'
import Inquiry from './components/inquiry.vue'
// import Router from 'vue-router'

// Import Views - Dash
import DashboardView from './components/views/Dashboard.vue'
import AccountGroup from './components/views/account/AccountGroup.vue'
import AccountSubGroup from './components/views/account/AccountSubGroup.vue'
import AccountSubGroupChild from './components/views/account/AccountSubGroupChild.vue'
import AccountMaster from './components/views/account/AccountMaster.vue'
import MonthlyTarget from './components/views/account/monthlySalesTarget.vue'
import IncomeAccount from './components/views/account/incomeAccount.vue'
import ExpensesAccount from './components/views/account/expensesAccount.vue'
import SupplierAccount from './components/views/account/SupplierAccount.vue'
import CustomerAccount from './components/views/account/CustomerAccount.vue'
import CustomerFollowUpList from './components/views/account/followUpCustomerList.vue'
import BankDetail from './components/views/account/BankDetail.vue'
import ItemGroup from './components/views/item/Itemgroup.vue'
import Itemsubgroup from './components/views/item/Itemsubgroup.vue'
import ItemMaster from './components/views/item/ItemMaster.vue'
import MeasurementUnit from './components/views/item/MeasurementUnit.vue'
import UnitConversion from './components/views/item/UnitConversions.vue'
import Commision from './components/views/settings/CommisionSetup/commision.vue'
import ItemProperty from './components/views/settings/itemProperty/property.vue'
import WarehouseGroup from './components/views/warehouse/WarehouseGroup.vue'
import Warehouse from './components/views/warehouse/Warehouse.vue'
import BillSundryPurchase from './components/views/billsundry/BillSundryPurchase.vue'
import BillSundrySales from './components/views/billsundry/BillSundrySales.vue'
import TransportationDetails from './components/views/billsundry/transportationDetails.vue'
import Journal from './components/views/accounting/journal.vue'
import Payment from './components/views/accounting/payment.vue'
import receipt from './components/views/accounting/receipt.vue'
import creditnote from './components/views/accounting/creditnote.vue'
import debitnote from './components/views/accounting/debitnote.vue'
import salesorder from './components/views/sales/salesorder.vue'
import saleschallan from './components/views/sales/saleschallan.vue'
import salesinvoice from './components/views/sales/salesinvoice.vue'
import dairySalesInvoice from './components/views/sales/salesInvoiceDairy.vue'
import salesreturn from './components/views/sales/salesreturn.vue'
import salesReturnBillWise from './components/views/sales/salesReturnBillWise.vue'
import consumption from './components/views/sales/consumption.vue'
import damage from './components/views/sales/damage.vue'
import purchaseorder from './components/views/purchase/purchaseorder.vue'
import purchasechallan from './components/views/purchase/purchasechallan.vue'
import purchaseinvoice from './components/views/purchase/purchaseinvoice.vue'
import dairyPurchaseInvoice from './components/views/purchase/dairyPurchaseInvoice.vue'
import purchasereturn from './components/views/purchase/purchasereturn.vue'
import purchaseReturnBillWise from './components/views/purchase/purchaseReturnBillWise.vue'
import finishedGoods from './components/views/purchase/finishedGoods.vue'
import cashwithdraw from './components/views/banking/cashwithdraw.vue'
import cashdeposit from './components/views/banking/cashdeposit.vue'
import banktransfer from './components/views/banking/banktransfer.vue'
import cashBook from './components/views/basicAccountingReport/cashBook.vue'
import dayBookWithoutCash from './components/views/basicAccountingReport/dayBookWithoutCash.vue'
import dayBook from './components/views/basicAccountingReport/dayBook.vue'
import ledgerInquery from './components/views/basicAccountingReport/ledgerInquery.vue'
import journalAll from './components/views/basicAccountingReport/journalAll.vue'
import journalVoidAll from './components/views/basicAccountingReport/journalVoidReport.vue'
import journalPendingReport from './components/views/basicAccountingReport/journalPendingReport.vue'
import journalBook from './components/views/basicAccountingReport/journalBook.vue'
import reversalBook from './components/views/basicAccountingReport/reversalBook.vue'
import receiptBook from './components/views/basicAccountingReport/receiptBook.vue'
import paymentBook from './components/views/basicAccountingReport/paymentBook.vue'
import debitNoteRegister from './components/views/basicAccountingReport/debitNoteRegister.vue'
import creditNoteRegister from './components/views/basicAccountingReport/creditNoteRegister.vue'
import cashDepositRegister from './components/views/basicAccountingReport/cashDepositRegister.vue'
import cashWithdrawalRegister from './components/views/basicAccountingReport/cashWithdrawalRegister.vue'
import bankTransferRegister from './components/views/basicAccountingReport/bankTransferRegister.vue'
import trailBalance from './components/views/finalAccountingReport/trailBalanceReport.vue'
import trailBalanceOpening from './components/views/finalAccountingReport/trialBalanceOpeningReport.vue'
import profitAndLoss from './components/views/finalAccountingReport/profitandlossReport.vue'
import balanceSheet from './components/views/finalAccountingReport/balanceSheetReport.vue'
import tradingAccount from './components/views/finalAccountingReport/tradingReport.vue'
import incomeAndExpenses from './components/views/finalAccountingReport/incomeAndExpensesReport.vue'
import purchaseOrderReport from './components/views/purchaseReport/purchaseOrderReport.vue'
import purchaseChallanReport from './components/views/purchaseReport/purchaseChallanReport.vue'
import purchaseInvoiceReport from './components/views/purchaseReport/purchaseInvoiceReport.vue'
import purchaseTaxRegister from './components/views/purchaseReport/purchaseTaxRegister.vue'
import purchaseSummaryReport from './components/views/purchaseReport/purchaseSummaryReport.vue'
import salesOrderReport from './components/views/salesReport/salesOrderReport.vue'
import salesOrderCompletedReport from './components/views/salesReport/salesOrderCompletedReport.vue'
import salesOrderPendingReport from './components/views/salesReport/salesOrderPendingReport.vue'
import salesChallanReport from './components/views/salesReport/salesChallanReport.vue'
import salesInvoiceReport from './components/views/salesReport/salesInvoiceReport.vue'
import salesInvoiceUnpaidReport from './components/views/salesReport/salesInvoiceUnpaidReport.vue'
import salesInvoiceChequeReceived from './components/views/salesReport/salesInvoiceChequeReceived.vue'
import salesInvoiceTodayUnpaidReport from './components/views/salesReport/salesInvoiceTodayUnpaidReport.vue'
import SalesUnpaidAndPaidReport from './components/views/salesReport/SalesUnpaidAndPaidReport.vue'
import salesInvoiceUnreceivedReport from './components/views/salesReport/salesGoodsUnReceivedReport.vue'
import salesInvoicePaidReport from './components/views/salesReport/salesPaidReport.vue'
import salesInvoiceUnreceivedAllReport from './components/views/salesReport/salesInvoiceUnreceivedAllReport.vue'
import salesInvoiceVoidReport from './components/views/salesReport/salesInvoiceVoidReport.vue'
import salesTaxRegister from './components/views/salesReport/salesTaxRegister.vue'
import salesSummaryReport from './components/views/salesReport/salesSummaryReport.vue'
import consumptionReport from './components/views/salesReport/consumptionReport.vue'
import damageReport from './components/views/salesReport/damageReport.vue'
import finishedGoodsReport from './components/views/purchaseReport/finishedGoodsReport.vue'
import SalesUnpaidNextFollowUpReport from './components/views/salesReport/salesUnPaidNextFollowUpBetweeen.vue'
import SalesPaymentTodaysFollowUpReport from './components/views/salesReport/salesPaymentTodysFollowUp.vue'
// Settings
import user from './components/views/settings/user.vue'
import role from './components/views/settings/role.vue'
import branchCompany from './components/views/settings/branchCompany.vue'
import fiscalYear from './components/views/settings/fiscalYear.vue'
import autoSettelTransaction from './components/views/settings/autoSettelTransaction.vue'
// import masterSetupAccount from './components/views/settings/masterSetupAccount'
// import masterSetupInventory from './components/views/settings/masterSetupInventory'
import BasicAccountSetup from './components/views/settings/BasicAccountSetup'
import sendSms from './components/views/settings/sms/sendSms.vue'
import smsReport from './components/views/settings/sms/smsReport.vue'
import smsSentReport from './components/views/settings/sms/smsSentReport.vue'
import smsFailedReport from './components/views/settings/sms/smsFailedReport.vue'
// Settings
import salesReturnReport from './components/views/salesReport/salesReturnReport'
import purchaseReturnReport from './components/views/purchaseReport/purchaseReturnReport'
import purchaseDetailReport from './components/views/purchaseReport/purchaseDetailReport.vue'
import purchaseDetailsDairyReport from './components/views/purchaseReport/purchaseDetailsDairyReport.vue'
import salesDetailsDairyReport from './components/views/salesReport/salesDetailsDairyReport.vue'
import salesDetailReport from './components/views/salesReport/salesDetailReport.vue'
import inventoryInOutReport from './components/views/inventoryReports/inventoryInOutReport.vue'
import itemDayBook from './components/views/inventoryReports/itemDayBook.vue'
import closingStock from './components/views/inventoryReports/closingStock.vue'
import itemInOutStoreWise from './components/views/inventoryReports/itemInOutStoreWise.vue'
import itemMasterListForRates from './components/views/inventoryReports/itemMasterListForRates.vue'
import itemStatementReport from './components/views/inventoryReports/itemStatement.vue'
import itemPurchaseDetailReport from './components/views/inventoryReports/itemPurchaseDetails.vue'
import itemSalesDetailReport from './components/views/inventoryReports/itemSalesDetails.vue'
import partyReport from './components/views/partyReport/partyStatement.vue'
import supplierTransactionSummary from './components/views/partyReport/supplierTransactionSummary.vue'
import customerTransactionSummary from './components/views/partyReport/customerTransactionSummary.vue'
import bankStatement from './components/views/bankReports/bankStatement.vue'
import bankClosingBalExcludingOverDraft from './components/views/bankReports/bankClosingBalExcludingOverDraft.vue'
import bankClosingBalIncludingOverDraft from './components/views/bankReports/bankClosingBalIncludingOverDraft.vue'
import bankClosingBalOnlyOverDraft from './components/views/bankReports/bankClosingBalOnlyOverDraft.vue'
import postDateChequeDetails from './components/views/bankReconcilation/postDateChequeDetails.vue'
import reconciliationStatement from './components/views/bankReconcilation/reconciliationStatement.vue'
import postDateCheque from './components/views/banking/postDatedCheque.vue'
import postDateChequeClear from './components/views/bankReconcilation/postDatedChequeDetailCleared.vue'
import postDateChequeUnclear from './components/views/bankReconcilation/postDatedChequeDetailUncleared.vue'
import customerReceivableReport from './components/views/outstandingReports/customerReceivableReport.vue'
import supplierPayableReport from './components/views/outstandingReports/supplierPayableReport.vue'
import storeWiseClosingStock from './components/views/inventoryReports/storeWiseClosingStock.vue'
import storeWiseClosingStockUser from './components/views/inventoryReports/storeWiseClosingStockUser.vue'
import storeAndItemWiseClosingStock from './components/views/inventoryReports/closingStockStoreAndItemWise.vue'
import negativeStockReport from './components/views/inventoryReports/itemNegativeStock.vue'
import IRDSetup from './components/views/settings/IRDSetup.vue'
// import Test from './components/views/test/test'
// Admin Modules
import adminOrganization from './components/views/admin/adminOrganization.vue'
import adminUser from './components/views/admin/adminUser.vue'
import allUser from './components/views/admin/allUserList.vue'
import adminInquiry from './components/views/admin/inquiry.vue'
import printPage from './components/views/printPages/printPage.vue'
import arbPrint from './components/views/printPages/arbPrint.vue'

// Delivery Module
import deliveryEntryForm from './components/views/delivery/deliveryEntryForm'
import deliveryReport from './components/views/delivery/deliveryReport'
import deliveryUserTrack from './components/views/delivery/trackDeliveryHistory'
import deliveredReport from './components/views/delivery/deliveredReport'
import vendorDeliveryReport from './components/views/delivery/vendorDeliveryReport'
import deliveryRequestReport from './components/views/delivery/deliveryRequestReport'
import deliveryPendingReport from './components/views/delivery/pendingDeliveryReport'
import vendorPaidReport from './components/views/delivery/vendorPaidReport'
import vendorUnPaidReport from './components/views/delivery/vendorUnPaidReport'
import deliveryRemarksLogReport from './components/views/delivery/deliveryRemarksLogReport'
import deliveryCancelledReport from './components/views/delivery/deliveryCancelledReport'
import deliveryReturnedReport from './components/views/delivery/deliveryReturnedToVendorReport'
import toBeVerifyDelivery from './components/views/delivery/toBeVerifyDelivery'
// Stock Transfor
import stockTransferInternal from './components/views/stockTransfer/stockTransferInternal'
import stockTransforReportInternal from './components/views/stockTransfer/stockTransforInternalReport'
import stockTransforReportWarehouseWise from './components/views/stockTransfer/stockTransforReportWarehouseWise'
import stockTransforDetails from './components/views/stockTransfer/stockTransforDetails'
import stockTransforDetailsStoreWise from './components/views/stockTransfer/stockTransforDetailStoreWise'
import stockTransforReportInternalUser from './components/views/stockTransfer/stockTransforInternalReportUser'
import stockTransforDetailsUser from './components/views/stockTransfer/stockTransforDetailsUser'

// NOC Pos
import nocPosSales from './components/views/pos/nocPosSales.vue'
// Pos
import posentry from './components/views/pos/posEntry.vue'
import voucher from './components/views/commonDialogs/voucher.vue'
import Qrcode from './components/views/commonDialogs/QrCode.vue'
import posSalesReport from './components/views/pos/posSalesReport.vue'
import posSalesCustomerReport from './components/views/pos/posCustomerSalesReport.vue'
import unSettlePosSalesReport from './components/views/pos/posUnSettleSales.vue'
import posUnpaidReport from './components/views/pos/posUnpaidReport.vue'
import PosPrintPage from './components/views/pos/posPrintPage.vue'
import QotPrintPage from './components/views/pos/qotPrintPage.vue'
import CounterSetup from './components/views/pos/counter/counterSetup.vue'
import PosUnsettledDetails from './components/views/pos/posUnsettledDetails.vue'
import DailySalesReport from './components/views/pos/dailySalesReport.vue'
import DeliveryPrintPage from './components/views/pos/deliveryPrintPage.vue'
import PosSalesReturnBillwise from './components/views/pos/posSalesReturnBillwise.vue'
import ItemWiseStockMgmt from './components/views/pos/ItemWiseStockMgmt.vue'
import PosClosingStock from './components/views/pos/posClosingStock.vue'
import stockInHistoryReport from './components/views/pos/stockInHistoryReport.vue'
import posAllUnPaidReport from './components/views/pos/posAllUnPaidReport.vue'
import posSalesDeleteReport from './components/views/pos/posSalesDeleteReport.vue'
import rewardPoint from './components/views/pos/RewardPoint.vue'
import posDublicateSalesReport from './components/views/pos/dublicatePosSalesEntry.vue'
import posCustomerReport from './components/views/pos/posCustomerReport.vue'

// Human Resource
import jobTitle from './components/views/HumanResource/Job/jobTitle.vue'
import employmentStatus from './components/views/HumanResource/Job/employmentStatus.vue'
import jobCategory from './components/views/HumanResource/Job/jobCategory.vue'
import workShift from './components/views/HumanResource/Job/workShift.vue'
import shiftManagement from './components/views/HumanResource/Job/shiftManagement.vue'
import terminationReason from './components/views/HumanResource/Job/terminationReason.vue'
import skills from './components/views/HumanResource/Qualification/skills.vue'
import education from './components/views/HumanResource/Qualification/education.vue'
import language from './components/views/HumanResource/Qualification/language.vue'
import license from './components/views/HumanResource/Qualification/license.vue'
import membership from './components/views/HumanResource/Qualification/membership.vue'
import nationality from './components/views/HumanResource/Qualification/nationality.vue'
import leaveType from './components/views/HumanResource/Leave/leaveType.vue'
import holidays from './components/views/HumanResource/Leave/holidays.vue'
import leavePeriod from './components/views/HumanResource/Leave/leavePeriod.vue'
import workingWeek from './components/views/HumanResource/Leave/workingWeek.vue'
import leaveEntitlement from './components/views/HumanResource/Leave/leaveEntitlement.vue'
import payHead from './components/views/HumanResource/Pay/payHead.vue'
import payGrade from './components/views/HumanResource/Pay/payGrades.vue'
import addEmployee from './components/views/HumanResource/Employee/employee.vue'
import employeeDetails from './components/views/HumanResource/Employee/employeeDetails.vue'
import employee from './components/views/HumanResource/Employee/createEmployee.vue'
import leaveRequest from './components/views/HumanResource/Leave/leaveRequest.vue'
import leaveReports from './components/views/HumanResource/Leave/leaveReports.vue'
import attendanceRequest from './components/views/HumanResource/Attendance/attendanceRequest.vue'
import employeeGroup from './components/views/HumanResource/Employee/employeeGroup.vue'
import employeePosition from './components/views/HumanResource/Employee/employeePosition.vue'
import employeeSubGroup1 from './components/views/HumanResource/Employee/employeeSubGroup1.vue'
import attendanceRequestReport from './components/views/HumanResource/Attendance/attendanceRequestReport.vue'
import salaryEntry from './components/views/HumanResource/PayRoll/SalaryEntry.vue'
import salaryReport from './components/views/HumanResource/PayRoll/SalaryReport.vue'
import InventoryAssignEntry from './components/views/HumanResource/InventoryAssign/InventoryAssignEntry.vue'
import InventoryAssignReport from './components/views/HumanResource/InventoryAssign/InventoryAssignReport.vue'
import profile from './components/views/HumanResource/profile.vue'
import assignDetails from './components/views/HumanResource/InventoryAssign/assignDetails.vue'
import EmployeeTransfer from './components/views/HumanResource/Employee/EmployeeTransfer.vue'

// Analysis Reports
import purchaseAnalysisProductWise from './components/views/analysisReport/purchaseAnalysisProductWise.vue'
import salesAnalysisProductWise from './components/views/analysisReport/salesAnalysisProductWise'
import purchaseAnalysisSupplierWise from './components/views/analysisReport/purchaseAnalysisSupplierWise.vue'
import salesAnalysisCustomerWise from './components/views/analysisReport/salesAnalysisCustomerWise'
import CustomerWiseSalesCount from './components/views/analysisReport/CustomerWiseSalesCount.vue'
import purchaseAnalysisMonthlyProductWise from './components/views/analysisReport/purchaseAnalysisMonthlyProductWise.vue'
import salesAnalysisMonthlyProductWise from './components/views/analysisReport/salesAnalysisMonthlyProductWise'
import purchaseAnalysisMonthlySupplierWise from './components/views/analysisReport/purchaseAnalysisMonthlySupplierWise.vue'
import salesAnalysisMonthlyCustomerWise from './components/views/analysisReport/salesAnalysisMonthlyCustomerWise'
import salesAnalysisMonthlyCustomerFiscalYearWise from './components/views/analysisReport/salesAnalysisFiscalYearWiseMonthly'

import purchaseAnalysisQuarterlyProductWise from './components/views/analysisReport/purchaseAnalysisQuarterlyProductWise.vue'
import salesAnalysisQuarterlyProductWise from './components/views/analysisReport/salesAnalysisQuarterlyProductWise'
import purchaseAnalysisQuarterlySupplierWise from './components/views/analysisReport/purchaseAnalysisQuarterlySupplierWise.vue'
import salesAnalysisQuarterlyCustomerWise from './components/views/analysisReport/salesAnalysisQuarterlyCustomerWise'

import profitAndLossAnalysisProductWise from './components/views/analysisReport/profitAndLossAnalysisProductWise.vue'
import profitAndLossAnalysis from './components/views/analysisReport/profitAndLossAnalysisAccountAndProduct.vue'
import profitReportGross from './components/views/analysisReport/profitReportGross.vue'
import expensesReport from './components/views/analysisReport/expensesReport.vue'
import salesPaidCollectionReport from './components/views/analysisReport/salesPaidCollectionReport.vue'
import monthlyDueAnalysisReport from './components/views/analysisReport/paymentDueAnalysis.vue'
// FixedAssets
import categorySetup from './components/views/fixedAssets/categorySetup.vue'
import subCategorySetup from './components/views/fixedAssets/subCategory.vue'
import faItemMaster from './components/views/fixedAssets/faItemMaster.vue'
import poolConfiguration from './components/views/fixedAssets/poolConfiguration.vue'
import faExtraExpenses from './components/views/fixedAssets/faExtraExpenses.vue'
import faExtraExpensesItemwise from './components/views/fixedAssets/faExtraExpensesItemwise.vue'

import fixedAssetsSalesOrder from './components/views/fixedAssetsSales/fixedAssetsSalesOrder.vue'
import fixedAssetsSalesChallan from './components/views/fixedAssetsSales/fixedAssetsSalesChallan.vue'
import fixedAssetsSalesInvoice from './components/views/fixedAssetsSales/fixedAssetsSalesInvoice.vue'
// import salesreturn from './components/views/sales/salesreturn.vue'
import fixedAssetsPurchaseOrder from './components/views/fixedAssetsPurchase/fixedAssetsPurchaseOrder.vue'
import fixedAssetsPurchaseChallan from './components/views/fixedAssetsPurchase/fixedAssetsPurchaseChallan.vue'
import fixedAssetsPurchaseInvoice from './components/views/fixedAssetsPurchase/fixedAssetsPurchaseInvoice.vue'
// import purchasereturn from './components/views/purchase/purchasereturn.vue'

// evnent Management
import eventRegistration from './components/views/eventManagement/registerEvent.vue'
import eventReport from './components/views/eventManagement/eventReport.vue'

// Crm
import crmClientDetails from './components/views/crm/crmClientDetails.vue'
import crmCustomer from './components/views/crm/crmCustomer.vue'
import crmCompanies from './components/views/crm/crmCompanies.vue'
import crmDealDetails from './components/views/crm/crmDealDetails.vue'
import crmProductDetails from './components/views/crm/crmProductDetails.vue'
import crmTaskDetails from './components/views/crm/crmTaskDetails.vue'
import crmTicketDetails from './components/views/crm/crmTicketDetails.vue'
import crmVIsitorDetails from './components/views/crm/crmVIsitorDetails.vue'
import crmFollowUpDetails from './components/views/crm/crmFollowUpDetails.vue'
import crmAllFollowUpDetails from './components/views/crm/crmAllList.vue'
import crmMasterSetup from './components/views/crm/crmMasterSetup.vue'
import crmCustomerWiseReport from './components/views/crm/crmCustomerWiseReport.vue'
import crmNotReceivedCalls from './components/views/crm/crmNotReceivedCalls.vue'
import crmTodayFollowUp from './components/views/crm/crmTodayFollowUp.vue'
import crmTotalTodayFollowUp from './components/views/crm/crmTotalFollowupByToday.vue'
import crmFollowUpDateRange from './components/views/crm/crmFollowUpDateRange.vue'
import quotationSent from './components/views/crm/quotationSent.vue'
import sampleSent from './components/views/crm/sampleSent.vue'
import crmStageWiseGraph from './components/crmGraph/crmStageWiseGraph.vue'
import crmUserWiseGraph from './components/crmGraph/crmUserWiseGraph.vue'
import crmUserWiseMonthlyGraph from './components/crmGraph/crmUserWiseMonthlyGraph.vue'
// Fiscal year settlement
import fiscalYearSettlement from './components/views/closingFinalYear/fiscalYearSettlement.vue'
import balanceBroughtDown from './components/views/closingFinalYear/balanceBroughtDown.vue'
import fiscalYearSettledReport from './components/views/closingFinalYear/fiscalYearSettledReport.vue'
import balanceCarryOverReport from './components/views/closingFinalYear/balanceCarryOverReport.vue'
import itemBroughtDownStoreWise from './components/views/closingFinalYear/itemBroughtDownStoreWise.vue'
// Production
import manufacturer from './components/views/production/Master/manufacturer.vue'
import manufacturingOverhead from './components/views/production/Master/manufacturingOverhead.vue'
import manufacturingProductionReport from './components/views/production/Master/manufacturingProductionReport.vue'
import batchSetup from './components/views/production/billOfMaterial/batchSetup.vue'
import batchProcessSetup from './components/views/production/billOfMaterial/batchProcessSetup.vue'
import batchProcessFormulaSetup from './components/views/production/billOfMaterial/batchProcessFormulaSetup.vue'
import executeBatch from './components/views/production/productionEntry/executeBatch.vue'
import processIssuedRaw from './components/views/production/productionEntry/processIssuedRaw.vue'
import stockJournalEntry from './components/views/production/productionEntry/stockJournalEntry.vue'
import blendReport from './components/views/production/Report/blendReport.vue'
import compileReport from './components/views/production/Report/compileReport.vue'
import dailyPurchaseReport from './components/views/production/Report/dailyPurchaseReport.vue'
import packingReport from './components/views/production/Report/packingReport.vue'
import stockJournalReport from './components/views/production/Report/stockJournalReport.vue'
import batchExecutedReport from './components/views/production/manufacturingInventory/batchExecutedReport.vue'
import itemIssueReport from './components/views/production/manufacturingInventory/itemIssueReport.vue'
import website from './components/views/ecommerce/website.vue'
import shop from './components/views/ecommerce/shop.vue'
import aboutUs from './components/views/ecommerce/aboutUs.vue'
import home from './components/views/ecommerce/home.vue'
import wishlist from './components/views/ecommerce/wishlist.vue'
import Login from './components/views/ecommerce/Login.vue'
import footerWebsite from './components/views/ecommerce/footerWebsite.vue'
import collections from './components/views/ecommerce/collections.vue'
import productDetails from './components/views/ecommerce/productDetails.vue'
import privacyPolicy from './components/views/ecommerce/privacyPolicy.vue'
import exchangeAndCancellations from './components/views/ecommerce/exchangeAndCancellations.vue'
import cart from './components/views/ecommerce/cart.vue'
import CreateAccount from './components/views/ecommerce/UserRegister.vue'
import contactUs from './components/views/ecommerce/contactUs.vue'
import ecommerceOrder from './components/views/ecommerce/ecommerceOrderList.vue'
import ecommerceCancelled from './components/views/ecommerce/ecommerceCancelledOrder.vue'
import ecommerceCompleted from './components/views/ecommerce/ecommerceCompletedOrder.vue'
import ecommercePending from './components/views/ecommerce/ecommercePending.vue'
import ecommerceHold from './components/views/ecommerce/ecommerceHoldOrder.vue'
import orderDetailReport from './components/views/ecommerce/orderDetails.vue'
import ecommerceInquiry from './components/views/ecommerce/inquiryDetailReport.vue'

// Excel upload
import excelUpload from './components/views/item/excelUpload.vue'

// Cost Center
import CostCenterGroup from './components/views/costCenter/CostCenterGroup.vue'
import CostCenterSubGroup from './components/views/costCenter/CostCenterSubGroup.vue'
import CostCenterSetup from './components/views/costCenter/CostCenterSetup.vue'
import CostCenterLedger from './components/views/costCenter/CostCenterLedger.vue'
import CostCenterSummary from './components/views/costCenter/CostCenterSummary.vue'

// Graph Report
import PurchaseSalesGraph from './components/views/graphReport/purchaseSalesGraph.vue'
import ReceiptPaymentGraph from './components/views/graphReport/receiptPaymentGraph.vue'
import SalesTragetGraph from './components/views/graphReport/salesTargetReportGraph.vue'
import ItemSalesMonthlyGraph from './components/views/graphReport/salesAnalyisItemWiseMonthly.vue'
import WeeklySalesReportGraph from './components/views/graphReport/WeeklySalesReportGraph.vue'
import ItemWiseProfitLossAnalysisGraph from './components/views/graphReport/ItemWiseProfitLossAnalysisGraph.vue'
import DailySalesReportGraph from './components/views/graphReport/DailySalesReportGraph.vue'
import CustomerWiseSalesCountGraph from './components/views/graphReport/CustomerWiseSalesCountGraph.vue'
import UserWiseSalesCounntGraph from './components/views/graphReport/UserWiseSalesCounntGraph.vue'
import GrossMarginGraph from './components/views/graphReport/GrossMarginGraph.vue'
import DueAnalysisGraph from './components/views/graphReport/monthlyDueAnalysisGraph.vue'
import salesPaidCashCollectionGraph from './components/views/graphReport/salesPaidCashCollectionGraph.vue'
// Routes
const routes = [
  {
    name: 'Login',
    path: '/login',
    component: LoginView
  },
  {
    path: '/website',
    component: website,
    name: 'website'
  },
  {
    path: '/footerWebsite',
    component: footerWebsite,
    name: 'footerWebsite'
  },
  {
    path: '/collections',
    component: collections,
    name: 'collections',
    props: true
  },
  {
    name: 'Product Detail',
    path: '/productDetails',
    component: productDetails,
    props: true
  },
  {
    name: 'Privacy Policy',
    path: '/privacyPolicy',
    component: privacyPolicy,
    props: true
  },
  {
    name: 'Exchange & Cancellations',
    path: '/exchangeAndCancellations',
    component: exchangeAndCancellations,
    props: true
  },
  {
    name: 'Cart',
    path: '/cart',
    component: cart,
    props: true
  },
  {
    path: '/contactUs',
    component: contactUs,
    name: 'Contact Us'
  },
  {
    path: '/home',
    component: home,
    name: 'Home',
    props: true
  },
  {
    path: '/shop',
    component: shop,
    name: 'Shop'
  },
  {
    path: '/aboutUs',
    component: aboutUs,
    name: 'About Us'
  },
  {
    path: '/wishlist',
    component: wishlist,
    name: 'Wish List'
  },
  {
    name: 'accountLogin',
    path: '/account/login',
    component: Login
  },
  {
    name: 'Create Account',
    path: '/account/createAccount',
    component: CreateAccount
  },
  {
    name: 'eventRegistration',
    path: '/eventRegistration',
    component: eventRegistration
  },
  {
    path: '/inquiry',
    component: Inquiry
  },
  {
    path: '/',
    component: DashView,
    children: [
      {
        path: 'dashboard',
        alias: '',
        component: DashboardView,
        name: 'Dashboard',
        meta: { requiresAuth: true }
      },
      // Admin Module Router
      {
        path: 'adminOrganization',
        component: adminOrganization,
        name: 'Organization',
        meta: { requiresAuth: true }
      }, {
        path: 'allUser',
        component: allUser,
        name: 'ALl User List',
        meta: { requiresAuth: true }
      },
      {
        path: 'adminUser',
        component: adminUser,
        name: 'Admin User',
        meta: { requiresAuth: true }
      },
      {
        path: 'adminInquiry',
        component: adminInquiry,
        name: 'Admin Inquiry',
        meta: {requiresAuth: true}
      },
      // Account Master Routes
      {
        path: 'accountGroup',
        component: AccountGroup,
        name: 'Account Group',
        meta: { requiresAuth: true }
      },
      {
        path: 'accountSubGroup',
        component: AccountSubGroup,
        name: 'Account Sub Group',
        meta: { requiresAuth: true }
      },
      {
        path: 'accountSubGroupChild',
        component: AccountSubGroupChild,
        name: 'Account Child Sub Group',
        meta: { requiresAuth: true }
      },
      {
        path: 'accountmaster',
        component: AccountMaster,
        name: 'General Account Master',
        meta: { requiresAuth: true }
      },
      {
        path: 'monthlyTarget',
        component: MonthlyTarget,
        name: 'Monthly Sales Target',
        meta: { requiresAuth: true }
      },
      {
        path: 'supplieraccount',
        component: SupplierAccount,
        name: 'Supplier Account',
        meta: { requiresAuth: true }
      },
      {
        path: 'customeraccount',
        component: CustomerAccount,
        name: 'Customer Account',
        meta: { requiresAuth: true }
      },
      {
        path: 'CustomerFollowUpList',
        component: CustomerFollowUpList,
        name: 'Customer FollowUp List',
        meta: { requiresAuth: true }
      },
      {
        path: 'incomeaccount',
        component: IncomeAccount,
        name: 'Income Account',
        meta: { requiresAuth: true }
      },
      {
        path: 'expensesaccount',
        component: ExpensesAccount,
        name: 'Expenses Account',
        meta: { requiresAuth: true }
      },
      {
        path: 'bankDetail',
        component: BankDetail,
        name: 'Bank Account',
        meta: { requiresAuth: true }
      },
      // Inventory routes
      {
        path: 'itemgroup',
        component: ItemGroup,
        name: 'Item Group',
        meta: { requiresAuth: true }
      },
      {
        path: 'itemsubgroup',
        component: Itemsubgroup,
        name: 'Item Sub Group',
        meta: { requiresAuth: true }
      },
      {
        path: 'itemmaster',
        component: ItemMaster,
        name: 'General Item Master',
        meta: { requiresAuth: true }
      },
      {
        path: 'measurementunit',
        component: MeasurementUnit,
        name: 'Measurement Unit',
        meta: { requiresAuth: true }
      },
      {
        path: 'unitConversion',
        component: UnitConversion,
        name: 'Unit Conversion',
        meta: { requiresAuth: true }
      },
      {
        path: 'warehousegroup',
        component: WarehouseGroup,
        name: 'Store Group',
        meta: { requiresAuth: true }
      },
      {
        path: 'warehouse',
        component: Warehouse,
        name: 'Store Master',
        meta: { requiresAuth: true }
      },
      {
        path: 'billsundrypurchase',
        component: BillSundryPurchase,
        name: 'Bill Sundry For Purchase ',
        meta: { requiresAuth: true }
      },
      {
        path: 'transportationDetails',
        component: TransportationDetails,
        name: 'Transportation Details',
        meta: { requiresAuth: true }
      },
      {
        path: 'billsundrysales',
        component: BillSundrySales,
        name: 'Bill Sundry For Sales ',
        meta: { requiresAuth: true }
      },
      {
        path: 'costCenterSubGroup',
        component: CostCenterSubGroup,
        name: 'Cost Center SubGroup',
        meta: { requiresAuth: true }
      },
      {
        path: 'costCenterGroup',
        component: CostCenterGroup,
        name: 'Cost Center Group',
        meta: { requiresAuth: true }
      },
      {
        path: 'costCenterSetup',
        component: CostCenterSetup,
        name: 'Cost Center Setup',
        meta: { requiresAuth: true }
      },
      {
        path: 'costCenterLedger',
        component: CostCenterLedger,
        name: 'Cost Center Ledger',
        meta: { requiresAuth: true }
      },
      {
        path: 'costCenterSummary',
        component: CostCenterSummary,
        name: 'Cost Center Summary',
        meta: { requiresAuth: true }
      },
      // Accounting routes
      {
        path: 'journal',
        component: Journal,
        props: true,
        name: 'Journal Entry',
        meta: { requiresAuth: true }
      },
      {
        path: 'payment',
        component: Payment,
        props: true,
        name: 'Payment Entry',
        meta: { requiresAuth: true }
      },
      {
        path: 'receipt',
        component: receipt,
        props: true,
        name: 'Receipt Entry',
        meta: { requiresAuth: true }
      },
      {
        path: 'creditnote',
        component: creditnote,
        name: 'Credit Note (w/o items)',
        meta: { requiresAuth: true }
      },
      {
        path: 'debitnote',
        component: debitnote,
        name: 'Debit Note (w/o items)',
        meta: { requiresAuth: true }
      },
      // Stock Transfor  routes
      {
        path: 'stockTransferInternal',
        component: stockTransferInternal,
        name: 'Stock Transfer (Internal)',
        props: true,
        meta: { requiresAuth: true }
      },
      {
        path: 'stockTransforReportWarehouseWise',
        component: stockTransforReportWarehouseWise,
        name: 'Stock Transfor Report Store Wise',
        props: true,
        meta: { requiresAuth: true }
      },
      {
        path: 'stockTransforReportInternal',
        component: stockTransforReportInternal,
        name: 'Stock Transfor Report (Internal)',
        props: true,
        meta: { requiresAuth: true }
      },
      {
        path: 'stockTransforReportInternalUser',
        component: stockTransforReportInternalUser,
        name: 'Stock Transfor Report (Internal) User',
        props: true,
        meta: { requiresAuth: true }
      },
      {
        path: 'stockTransforDetails',
        component: stockTransforDetails,
        name: 'stock Transfor Details',
        props: true,
        meta: { requiresAuth: true }
      },
      {
        path: 'stockTransforDetailsStoreWise',
        component: stockTransforDetailsStoreWise,
        name: 'stock Transfor Details Store Wise',
        props: true,
        meta: { requiresAuth: true }
      },
      {
        path: 'stockTransforDetailsUser',
        component: stockTransforDetailsUser,
        name: 'stock Transfor Details User',
        props: true,
        meta: { requiresAuth: true }
      },
      // Sales  routes
      {
        path: 'salesorder',
        component: salesorder,
        name: 'Sales Order',
        props: true,
        meta: { requiresAuth: true }
      },
      {
        path: 'saleschallan',
        component: saleschallan,
        name: 'Sales Challan',
        props: true,
        meta: { requiresAuth: true }
      },
      {
        path: 'salesinvoice',
        component: salesinvoice,
        name: 'Sales Invoice',
        props: true,
        meta: { requiresAuth: true }
      },
      {
        path: 'dairySalesInvoice',
        component: dairySalesInvoice,
        name: 'Dairy Sales Invoice',
        props: true,
        meta: { requiresAuth: true }
      },
      {
        path: 'salesreturn',
        component: salesreturn,
        props: true,
        name: 'Sales Return(Cr. Note)',
        meta: { requiresAuth: true }
      },
      {
        path: 'salesReturnBillWise',
        component: salesReturnBillWise,
        name: 'Sales Return Bill Wise',
        meta: {requiresAuth: true}
      },
      {
        path: 'consumption',
        component: consumption,
        name: 'Consumption',
        props: true,
        meta: { requiresAuth: true }
      },
      {
        path: 'damage',
        component: damage,
        name: 'Damage',
        props: true,
        meta: { requiresAuth: true }
      },
      // Purchase Routes
      {
        path: 'purchaseorder',
        component: purchaseorder,
        name: 'Purchase Order',
        props: true,
        meta: { requiresAuth: true }
      },
      {
        path: 'purchasechallan',
        component: purchasechallan,
        name: 'Purchase Challan',
        props: true,
        meta: { requiresAuth: true }
      },
      {
        path: 'purchaseinvoice',
        component: purchaseinvoice,
        name: 'Purchase Invoice',
        props: true,
        meta: { requiresAuth: true }
      },
      {
        path: 'dairyPurchaseInvoice',
        component: dairyPurchaseInvoice,
        name: 'Dairy Purchase Invoice',
        props: true,
        meta: { requiresAuth: true }
      },
      {
        path: 'finishedGoods',
        component: finishedGoods,
        name: 'Finished Goods',
        props: true,
        meta: { requiresAuth: true }
      },
      {
        path: 'purchasereturn',
        component: purchasereturn,
        name: 'Purchase Return(Dr. Note)',
        props: true,
        meta: { requiresAuth: true }
      },
      {
        path: 'purchaseReturnBillWise',
        component: purchaseReturnBillWise,
        name: 'Purchase Return Bill Wise',
        meta: {requiresAuth: true}
      },
      // Banking route
      {
        path: 'cashdeposit',
        props: true,
        component: cashdeposit,
        name: 'Cash Deposit',
        meta: { requiresAuth: true }
      },
      {
        path: 'cashwithdraw',
        props: true,
        component: cashwithdraw,
        name: 'Cash Withdraw',
        meta: { requiresAuth: true }
      },
      {
        path: 'banktransfer',
        props: true,
        component: banktransfer,
        name: 'Bank Transfer',
        meta: { requiresAuth: true }
      },
      {
        path: 'dayBook ',
        component: dayBook,
        name: 'Day Book',
        meta: { requiresAuth: true }
      },
      {
        path: 'dayBookWithoutCash',
        component: dayBookWithoutCash,
        name: 'Day Book w/o cash',
        meta: { requiresAuth: true }
      },
      {
        path: 'cashBook',
        component: cashBook,
        name: 'Cash Book',
        meta: { requiresAuth: true }
      },
      {
        path: 'journalBook',
        component: journalBook,
        name: 'Journal Register',
        meta: { requiresAuth: true, keepAlive: true }
      },
      {
        path: 'journalPendingReport',
        component: journalPendingReport,
        name: 'Journal Pending Report',
        meta: { requiresAuth: true, keepAlive: true }
      },
      {
        path: 'reversalBook',
        component: reversalBook,
        name: 'Reversal Register',
        meta: { requiresAuth: true, keepAlive: true }
      },
      {
        path: 'journalAll',
        component: journalAll,
        name: 'Transactions Register',
        meta: { requiresAuth: true, keepAlive: true }
      },
      {
        path: 'journalVoidAll',
        component: journalVoidAll,
        name: 'Transactions Void Register',
        meta: { requiresAuth: true, keepAlive: true }
      },
      {
        path: 'receiptBook',
        component: receiptBook,
        name: 'Receipt Register',
        meta: { requiresAuth: true, keepAlive: true }
      },
      {
        path: 'paymentBook',
        component: paymentBook,
        name: 'Payment Register',
        meta: { requiresAuth: true, keepAlive: true }
      },
      {
        path: 'debitNoteRegister',
        component: debitNoteRegister,
        name: 'Debit Note Register',
        meta: { requiresAuth: true, keepAlive: true }
      },
      {
        path: 'creditNoteRegister',
        component: creditNoteRegister,
        name: 'Credit Note Register',
        meta: { requiresAuth: true, keepAlive: true }
      },
      {
        path: 'cashDepositRegister',
        component: cashDepositRegister,
        name: 'Cash Deposit Register',
        meta: { requiresAuth: true, keepAlive: true }
      },
      {
        path: 'cashWithdrawalRegister',
        component: cashWithdrawalRegister,
        name: 'Cash Withdrawal Register',
        meta: { requiresAuth: true, keepAlive: true }
      },
      {
        path: 'bankTransferRegister',
        component: bankTransferRegister,
        name: 'Bank Transfer Register',
        meta: { requiresAuth: true, keepAlive: true }
      },
      {
        path: 'ledgerInquery',
        component: ledgerInquery,
        name: 'General Ledger / Statement',
        meta: { requiresAuth: true }
      },
      {
        path: 'trailBalance',
        component: trailBalance,
        name: 'Trial Balance - Closing',
        meta: { requiresAuth: true }
      },
      {
        path: 'trailBalanceOpening',
        component: trailBalanceOpening,
        name: 'Trial Balance - Opening',
        meta: { requiresAuth: true }
      },
      {
        path: 'profitAndLoss',
        component: profitAndLoss,
        name: 'Profit & Loss - Vertical',
        meta: { requiresAuth: true }
      },
      {
        path: 'balanceSheet',
        component: balanceSheet,
        name: 'Balance Sheet - Vertical',
        meta: { requiresAuth: true }
      },
      {
        path: 'incomeAndExpenses',
        component: incomeAndExpenses,
        name: 'Income And Expenses',
        meta: { requiresAuth: true }
      },
      {
        path: 'tradingAccount',
        component: tradingAccount,
        name: 'Trading Account',
        meta: { requiresAuth: true }
      },
      {
        path: 'bankStatement',
        component: bankStatement,
        name: 'Bank Ledger/Statement',
        meta: { requiresAuth: true }
      },
      {
        path: 'bankClosingBalExcludingOverDraft',
        component: bankClosingBalExcludingOverDraft,
        name: 'Bank Closing Balance - Excluding Overdraft ',
        meta: { requiresAuth: true }
      },
      {
        path: 'bankClosingBalIncludingOverDraft',
        component: bankClosingBalIncludingOverDraft,
        name: 'Bank Closing Balance - Including Overdraft ',
        meta: { requiresAuth: true }
      },
      {
        path: 'bankClosingBalOnlyOverDraft',
        component: bankClosingBalOnlyOverDraft,
        name: 'Bank Closing Balance - Only Overdraft ',
        meta: { requiresAuth: true }
      },
      {
        path: 'postDateCheque',
        component: postDateCheque,
        name: 'Post Date Cheque',
        meta: { requiresAuth: true }
      },
      {
        path: 'postDateChequeDetails',
        component: postDateChequeDetails,
        name: 'Post Date Cheque Details',
        meta: { requiresAuth: true }
      },
      {
        path: 'reconciliationStatement',
        component: reconciliationStatement,
        name: 'Reconciliation Statement',
        meta: { requiresAuth: true }
      },
      {
        path: 'postDateChequeClear',
        component: postDateChequeClear,
        name: 'Cleared Cheque Details',
        meta: { requiresAuth: true }
      },
      {
        path: 'postDateChequeUnclear',
        component: postDateChequeUnclear,
        name: 'Uncleared Cheque Details',
        meta: { requiresAuth: true }
      },
      {
        path: 'ecommerceOrder',
        component: ecommerceOrder,
        name: 'Ecommerce Order',
        props: true,
        meta: { requiresAuth: true, keepAlive: true }
      },
      {
        path: 'ecommerceCancelled',
        component: ecommerceCancelled,
        name: 'Ecommerce Cancelled',
        props: true,
        meta: { requiresAuth: true, keepAlive: true }
      },
      {
        path: 'ecommerceCompleted',
        component: ecommerceCompleted,
        name: 'Ecommerce Completed',
        props: true,
        meta: { requiresAuth: true, keepAlive: true }
      },
      {
        path: 'ecommercePending',
        component: ecommercePending,
        name: 'Ecommerce Pending',
        props: true,
        meta: { requiresAuth: true, keepAlive: true }
      },
      {
        path: 'ecommerceHold',
        component: ecommerceHold,
        name: 'Ecommerce Hold',
        props: true,
        meta: { requiresAuth: true, keepAlive: true }
      },
      {
        path: 'ecommerceInquiry',
        component: ecommerceInquiry,
        name: 'Inquiry Details',
        props: true,
        meta: { requiresAuth: true, keepAlive: true }
      },
      {
        path: 'salesOrderReport',
        component: salesOrderReport,
        name: 'Sales Order Report',
        props: true,
        meta: { requiresAuth: true, keepAlive: true }
      },
      {
        path: 'consumptionReport',
        component: consumptionReport,
        name: 'Consumption Report',
        meta: { requiresAuth: true, keepAlive: true }
      },
      {
        path: 'damageReport',
        component: damageReport,
        name: 'Damage Report',
        meta: { requiresAuth: true, keepAlive: true }
      },
      {
        path: 'salesOrderCompletedReport',
        component: salesOrderCompletedReport,
        name: 'Sales Order Completed Report',
        meta: { requiresAuth: true, keepAlive: true }
      },
      {
        path: 'salesOrderPendingReport',
        component: salesOrderPendingReport,
        name: 'Sales Order Pending Report',
        meta: { requiresAuth: true, keepAlive: true }
      },
      {
        path: 'salesChallanReport',
        component: salesChallanReport,
        name: 'Sales Challan Report',
        props: true,
        meta: { requiresAuth: true, keepAlive: true }
      },
      {
        path: 'salesInvoiceReport',
        component: salesInvoiceReport,
        name: 'Sales Invoice Report',
        props: true,
        meta: { requiresAuth: true, keepAlive: true }
      },
      {
        path: 'salesInvoiceUnpaidReport',
        component: salesInvoiceUnpaidReport,
        name: 'Sales Invoice Unpaid Report',
        props: true,
        meta: { requiresAuth: true, keepAlive: true }
      },
      {
        path: 'salesInvoiceChequeReceived',
        component: salesInvoiceChequeReceived,
        name: 'Sales Invoice Cheque Received Report',
        props: true,
        meta: { requiresAuth: true, keepAlive: true }
      },
      {
        path: 'salesInvoiceTodayUnpaidReport',
        component: salesInvoiceTodayUnpaidReport,
        name: 'Payment Todays Follow (TO-DO)',
        props: true,
        meta: { requiresAuth: true, keepAlive: true }
      },
      {
        path: 'salesInvoiceUnreceivedReport',
        component: salesInvoiceUnreceivedReport,
        name: 'Sales Invoice Unreceived Report',
        props: true,
        meta: { requiresAuth: true, keepAlive: true }
      },
      {
        path: 'salesInvoicePaidReport',
        component: salesInvoicePaidReport,
        name: 'Sales Invoice Paid Report',
        props: true,
        meta: { requiresAuth: true, keepAlive: true }
      },
      {
        path: 'salesInvoiceUnreceivedAllReport',
        component: salesInvoiceUnreceivedAllReport,
        name: 'Sales Invoice Unreceived All Report',
        props: true,
        meta: { requiresAuth: true, keepAlive: true }
      },
      {
        path: 'salesInvoiceUnpaidAndPaidReport',
        component: SalesUnpaidAndPaidReport,
        name: 'Sales Invoice Unpaid And Paid All Report',
        props: true,
        meta: { requiresAuth: true, keepAlive: true }
      },
      {
        path: 'salesUnpaidNextFollowUpReport',
        component: SalesUnpaidNextFollowUpReport,
        name: 'Sales Unpaid Next FollowUp Report',
        props: true,
        meta: { requiresAuth: true, keepAlive: true }
      },
      {
        path: 'salesPaymentFollowUpTodaysReport',
        component: SalesPaymentTodaysFollowUpReport,
        name: 'Payment Todays FollowUp (DONE) Report',
        props: true,
        meta: { requiresAuth: true, keepAlive: true }
      },
      {
        path: 'salesInvoiceVoidReport',
        component: salesInvoiceVoidReport,
        name: 'Sales Invoice Void Report',
        meta: { requiresAuth: true, keepAlive: true }
      },
      {
        path: 'salesSummaryReport',
        component: salesSummaryReport,
        name: 'sales Summary Report',
        meta: { requiresAuth: true, keepAlive: true }
      },
      {
        path: 'salesTaxRegister',
        component: salesTaxRegister,
        name: 'Sales Tax Regsiter',
        meta: { requiresAuth: true, keepAlive: true }
      },
      {
        path: 'salesDetailReport',
        component: salesDetailReport,
        name: 'sales Detail Report',
        props: true,
        meta: { requiresAuth: true }
      },
      {
        path: 'orderDetailReport',
        component: orderDetailReport,
        name: 'Order Details',
        props: true,
        meta: { requiresAuth: true }
      },
      {
        path: 'purchaseOrderReport',
        component: purchaseOrderReport,
        name: 'Purchase Order Report',
        meta: { requiresAuth: true, keepAlive: true }
      },
      {
        path: 'customerWiseSalesCount',
        component: CustomerWiseSalesCount,
        name: 'Customer Wise Sales Count',
        meta: { requiresAuth: true, keepAlive: true }
      },
      {
        path: 'purchaseChallanReport',
        component: purchaseChallanReport,
        name: 'Purchase Challan Report',
        meta: { requiresAuth: true, keepAlive: true }
      },
      {
        path: 'purchaseInvoiceReport',
        component: purchaseInvoiceReport,
        name: 'Purchase Invoice Report',
        meta: { requiresAuth: true, keepAlive: true }
      },
      {
        path: 'finishedGoodsReport',
        component: finishedGoodsReport,
        name: 'Finished Goods Report',
        meta: { requiresAuth: true, keepAlive: true }
      },
      {
        path: 'purchaseTaxRegister',
        component: purchaseTaxRegister,
        name: 'Purchase Tax Register',
        meta: { requiresAuth: true, keepAlive: true }
      },
      {
        path: 'purchaseSummaryReport',
        component: purchaseSummaryReport,
        name: 'Purchase Summary Report',
        meta: { requiresAuth: true, keepAlive: true }
      },
      {
        path: 'purchaseDetailReport',
        component: purchaseDetailReport,
        name: 'purchase Detail Report',
        props: true,
        meta: { requiresAuth: true }
      },
      {
        path: 'purchaseDetailsDairyReport',
        component: purchaseDetailsDairyReport,
        name: 'purchase Detail Dairy Report',
        props: true,
        meta: { requiresAuth: true }
      },
      {
        path: 'salesDetailsDairyReport',
        component: salesDetailsDairyReport,
        name: 'sales Detail Dairy Report',
        props: true,
        meta: { requiresAuth: true }
      },
      {
        path: 'inventoryInOutReport',
        component: inventoryInOutReport,
        name: 'Inventory In/Out Report',
        props: true,
        meta: { requiresAuth: true }
      },
      {
        path: 'storeWiseClosingStock',
        component: storeWiseClosingStock,
        name: 'Closing Stock Store Wise',
        props: true,
        meta: { requiresAuth: true }
      },
      {
        path: 'storeWiseClosingStockUser',
        component: storeWiseClosingStockUser,
        name: 'Closing Stock Store Wise User',
        props: true,
        meta: { requiresAuth: true }
      },
      // This 2 report semms similer but are differenet in function//
      {
        path: 'storeAndItemWiseClosingStock',
        component: storeAndItemWiseClosingStock,
        name: 'Store WiseClosing Stock',
        props: true,
        meta: { requiresAuth: true }
      },
      {
        path: 'negativeStockReport',
        component: negativeStockReport,
        name: 'Negative Stock Report',
        props: true,
        meta: { requiresAuth: true }
      },
      {
        path: 'itemDayBook',
        component: itemDayBook,
        name: 'Item Day Book',
        props: true,
        meta: { requiresAuth: true }
      },
      {
        path: 'closingStock',
        component: closingStock,
        name: 'Closing Stock',
        props: true,
        meta: { requiresAuth: true }
      },
      {
        path: 'itemStatement',
        component: itemStatementReport,
        name: 'Item Statement',
        props: true,
        meta: { requiresAuth: true }
      },
      {
        path: 'itemPurchaseDetailReport',
        component: itemPurchaseDetailReport,
        name: 'Item Purchase Detail Report',
        props: true,
        meta: { requiresAuth: true }
      },
      {
        path: 'itemSalesDetailReport',
        component: itemSalesDetailReport,
        name: 'Item Sales Detail Report',
        props: true,
        meta: { requiresAuth: true }
      },
      {
        path: 'itemInOutStoreWise',
        component: itemInOutStoreWise,
        name: 'Item InOut Store Wise',
        props: true,
        meta: { requiresAuth: true }
      },
      {
        path: 'itemMasterListForRates',
        component: itemMasterListForRates,
        name: 'Item List For Rate Update',
        props: true,
        meta: { requiresAuth: true }
      },
      {
        path: 'user',
        component: user,
        name: 'User',
        meta: { requiresAuth: true }
      },
      {
        path: 'irdsetup',
        component: IRDSetup,
        name: 'IRD Setup',
        meta: { requiresAuth: true }
      },
      {
        path: 'printPage',
        component: printPage,
        name: 'Print Page',
        meta: { requiresAuth: true }
      },
      {
        path: 'arbPrint',
        component: arbPrint,
        name: 'ARB Print Page',
        meta: { requiresAuth: true }
      },
      {
        path: 'basicAccountSetup',
        component: BasicAccountSetup,
        name: 'Basic Account setup',
        meta: { requiresAuth: true }
      },
      {
        path: 'sendSms',
        component: sendSms,
        name: 'Send SmS',
        meta: { requiresAuth: true }
      },
      {
        path: 'smsReport',
        component: smsReport,
        name: 'Sms Report',
        meta: { requiresAuth: true }
      },
      {
        path: 'smsSentReport',
        component: smsSentReport,
        name: 'Sms Sent Report',
        meta: { requiresAuth: true }
      },
      {
        path: 'smsFailedReport',
        component: smsFailedReport,
        name: 'Sms Failed Report',
        meta: { requiresAuth: true }
      },
      {
        path: 'deliveryEntryForm',
        component: deliveryEntryForm,
        name: 'Delivery Entry Form',
        meta: { requiresAuth: true }
      },
      {
        path: 'deliveryRequestReport',
        component: deliveryRequestReport,
        name: 'Delivery Request Report',
        meta: { requiresAuth: true }
      },
      {
        path: 'deliveryPendingReport',
        component: deliveryPendingReport,
        name: 'Delivery Pending Report',
        meta: { requiresAuth: true }
      },
      {
        path: 'vendorPaidReport',
        component: vendorPaidReport,
        name: 'Vendor Paid Report',
        meta: { requiresAuth: true }
      },
      {
        path: 'vendorUnPaidReport',
        component: vendorUnPaidReport,
        name: 'Vendor UnPaid Report',
        meta: { requiresAuth: true }
      },
      {
        path: 'vendorDeliveryReport',
        component: vendorDeliveryReport,
        name: 'Vendor Delivery Report',
        meta: { requiresAuth: true }
      },
      {
        path: 'deliveryRemarksLogReport',
        component: deliveryRemarksLogReport,
        name: 'Delivery Remarks Log Report',
        meta: { requiresAuth: true }
      },
      {
        path: 'deliveryCancelledReport',
        component: deliveryCancelledReport,
        name: 'Delivery Cancel Report',
        meta: { requiresAuth: true }
      },
      {
        path: 'deliveryReturnedReport',
        component: deliveryReturnedReport,
        name: 'Delivery Returned Report',
        meta: { requiresAuth: true }
      },
      {
        path: 'toBeVerifyDelivery',
        component: toBeVerifyDelivery,
        name: 'To Be Verify Delivery',
        meta: { requiresAuth: true }
      },
      {
        path: 'deliveredReport',
        component: deliveredReport,
        name: 'Delivery Completed Report',
        meta: { requiresAuth: true }
      },
      {
        path: 'deliveryReport',
        component: deliveryReport,
        name: 'Delivery Report',
        meta: { requiresAuth: true }
      },
      {
        path: 'deliveryUserTrack',
        component: deliveryUserTrack,
        name: 'Delivery User Track',
        meta: { requiresAuth: true }
      },
      {
        path: 'fixedAssetsSalesOrder',
        component: fixedAssetsSalesOrder,
        name: 'Fixed Assets Sales Order',
        props: true,
        meta: { requiresAuth: true }
      },
      {
        path: 'fixedAssetsSalesChallan',
        component: fixedAssetsSalesChallan,
        name: 'Fixed Assets Sales Challan',
        props: true,
        meta: { requiresAuth: true }
      },
      {
        path: 'fixedAssetsSalesInvoice',
        component: fixedAssetsSalesInvoice,
        name: 'Fixed Assets Sales Invoice',
        props: true,
        meta: { requiresAuth: true }
      },
      // {
      //   path: 'salesreturn',
      //   component: salesreturn,
      //   props: true,
      //   name: 'Sales Return(Cr. Note)',
      //   meta: { requiresAuth: true }
      // },
      {
        path: 'fixedAssetsPurchaseOrder',
        component: fixedAssetsPurchaseOrder,
        name: 'Fixed Assets Purchase Order',
        props: true,
        meta: { requiresAuth: true }
      },
      {
        path: 'fixedAssetsPurchaseChallan',
        component: fixedAssetsPurchaseChallan,
        name: 'Fixed Assets Purchase Challan',
        props: true,
        meta: { requiresAuth: true }
      },
      {
        path: 'fixedAssetsPurchaseInvoice',
        component: fixedAssetsPurchaseInvoice,
        name: 'Fixed Assets Purchase Invoice',
        props: true,
        meta: { requiresAuth: true }
      },
      {
        path: 'role',
        component: role,
        name: 'Role',
        meta: { requiresAuth: true }
      },
      {
        path: 'branchCompany',
        component: branchCompany,
        name: 'Branch Company',
        meta: { requiresAuth: true }
      },
      {
        path: 'fiscalYear',
        component: fiscalYear,
        name: 'Fiscal Year',
        meta: { requiresAuth: true }
      },
      {
        path: 'autoSettelTransaction',
        component: autoSettelTransaction,
        name: 'Auto Settle Inventory And Account',
        meta: { requiresAuth: true }
      },
      // {
      //   path: 'masterSetupAccount',
      //   component: masterSetupAccount,
      //   name: 'Master Setup Account',
      //   meta: { requiresAuth: true }
      // },
      // {
      //   path: 'masterSetupInventory',
      //   component: masterSetupInventory,
      //   name: 'Master Setup Inventory',
      //   meta: { requiresAuth: true }
      // },
      {
        path: 'commision',
        component: Commision,
        name: 'Commision',
        meta: { requiresAuth: true }
      },
      {
        path: 'property',
        component: ItemProperty,
        name: 'ItemProperty',
        meta: { requiresAuth: true }
      },
      {
        path: 'purchaseReturnReport',
        component: purchaseReturnReport,
        name: 'Purchase Return Report',
        meta: { requiresAuth: true, keepAlive: true }
      },
      {
        path: 'salesReturnReport',
        component: salesReturnReport,
        name: 'Sale Return Report',
        meta: { requiresAuth: true, keepAlive: true }
      },
      {
        path: 'partyStatement',
        component: partyReport,
        name: 'Party Ledger/Statement',
        meta: {requiresAuth: true}
      },
      {
        path: 'supplierTransactionSummary',
        component: supplierTransactionSummary,
        name: 'Supplier Transaction Summary',
        meta: {requiresAuth: true}
      },
      {
        path: 'customerTransactionSummary',
        component: customerTransactionSummary,
        name: 'Customer Transaction Summary',
        meta: {requiresAuth: true}
      },
      {
        path: 'customerReceivableReport',
        component: customerReceivableReport,
        name: 'Customer Receivable Report',
        meta: {requiresAuth: true}
      },
      {
        path: 'supplierPayableReport',
        component: supplierPayableReport,
        name: 'Supplier Payable Report',
        meta: {requiresAuth: true}
      },
      {
        path: 'posEntry',
        component: posentry,
        name: 'Point of Sales',
        props: true,
        meta: {requiresAuth: true}
      },
      {
        path: 'posSalesReport',
        component: posSalesReport,
        name: 'Pos Sales Report',
        meta: {requiresAuth: true}
      },
      {
        path: 'posCustomerSalesReport',
        component: posSalesCustomerReport,
        name: 'Pos Customer Sales Report',
        meta: {requiresAuth: true}
      },
      {
        path: 'unSettlePosSalesReport',
        component: unSettlePosSalesReport,
        name: 'UnSettle Report',
        props: true,
        meta: {requiresAuth: true}
      },
      {
        path: 'posUnpaidReport',
        component: posUnpaidReport,
        name: 'Pos Unpaid Report',
        meta: {requiresAuth: true}
      },
      {
        path: 'posUnsettledDetails',
        component: PosUnsettledDetails,
        name: 'Unsettled Details',
        props: true,
        meta: {requiresAuth: true}
      },
      {
        path: 'voucher',
        component: voucher,
        name: 'voucher',
        props: true,
        meta: {requiresAuth: true}
      },
      {
        path: 'qrPage',
        component: Qrcode,
        name: 'Qrcode',
        props: true,
        meta: {requiresAuth: true}
      },
      {
        path: 'posPrintPage',
        component: PosPrintPage,
        name: 'posPrintPage',
        props: true,
        meta: {requiresAuth: true}
      },
      {
        path: 'qotPrintPage',
        component: QotPrintPage,
        name: 'qotPrintPage',
        props: true,
        meta: {requiresAuth: true}
      },
      {
        path: 'counterSetup',
        component: CounterSetup,
        name: 'Counter Setup',
        // props: true,
        meta: {requiresAuth: true}
      },
      {
        path: 'posDailySalesReport',
        component: DailySalesReport,
        name: 'DailySalesReport',
        props: true,
        meta: {requiresAuth: true}
      },
      {
        path: 'posDeliveryPrint',
        component: DeliveryPrintPage,
        name: 'posDeliveryPrint',
        props: true,
        meta: {requiresAuth: true}
      },
      {
        path: 'posSalesReturnBillwise',
        component: PosSalesReturnBillwise,
        name: 'pos Sales Return Billwise',
        meta: {requiresAuth: true}
      },
      {
        path: 'posItemWiseStockMgmt',
        component: ItemWiseStockMgmt,
        name: 'Stock Adjustment',
        meta: {requiresAuth: true}
      },
      {
        path: 'posClosingStock',
        component: PosClosingStock,
        name: 'Pos Closing Stock',
        meta: {requiresAuth: true}
      },
      {
        path: 'stockInHistoryReport',
        component: stockInHistoryReport,
        name: 'Stock In History Report',
        meta: {requiresAuth: true}
      },
      {
        path: 'posSalesDeleteReport',
        component: posSalesDeleteReport,
        name: 'Pos Sales Deleted Report',
        meta: {requiresAuth: true}
      },
      {
        path: 'posAllUnPaidReport',
        component: posAllUnPaidReport,
        name: 'Pos All UnPaid Report',
        meta: {requiresAuth: true}
      },
      {
        path: 'posDublicateSalesReport',
        component: posDublicateSalesReport,
        name: 'Pos Dublicate Sales Report',
        meta: {requiresAuth: true}
      },
      {
        path: 'posCustomerReport',
        component: posCustomerReport,
        name: 'Pos Customer Report',
        meta: {requiresAuth: true}
      },
      {
        path: 'rewardPoint',
        component: rewardPoint,
        name: 'Reward Point',
        meta: {requiresAuth: true}
      },
      // Human Resource
      {
        path: 'jobTitle',
        component: jobTitle,
        name: 'Job title',
        meta: {requiresAuth: true}
      },
      {
        path: 'employmentStatus',
        component: employmentStatus,
        name: 'Employment Status',
        meta: {requiresAuth: true}
      },
      {
        path: 'jobCategory',
        component: jobCategory,
        name: 'Job Category',
        meta: {requiresAuth: true}
      },
      {
        path: 'workShift',
        component: workShift,
        name: 'Work Shift',
        meta: {requiresAuth: true}
      },
      {
        path: 'shiftManagement',
        component: shiftManagement,
        name: 'Shift Management',
        meta: {requiresAuth: true}
      },
      {
        path: 'terminationReason',
        component: terminationReason,
        name: 'Termination Reason',
        meta: {requiresAuth: true}
      },
      {
        path: 'skills',
        component: skills,
        name: 'skills',
        meta: {requiresAuth: true}
      },
      {
        path: 'education',
        component: education,
        name: 'education',
        meta: {requiresAuth: true}
      },
      {
        path: 'language',
        component: language,
        name: 'language',
        meta: {requiresAuth: true}
      },
      {
        path: 'license',
        component: license,
        name: 'license',
        meta: {requiresAuth: true}
      },
      {
        path: 'membership',
        component: membership,
        name: 'membership',
        meta: {requiresAuth: true}
      },
      {
        path: 'nationality',
        component: nationality,
        name: 'nationality',
        meta: {requiresAuth: true}
      },
      {
        path: 'leaveType',
        component: leaveType,
        name: 'leave Type',
        meta: {requiresAuth: true}
      },
      {
        path: 'holidays',
        component: holidays,
        name: 'holidays',
        meta: {requiresAuth: true}
      },
      {
        path: 'leavePeriod',
        component: leavePeriod,
        name: 'leave Period',
        meta: {requiresAuth: true}
      },
      {
        path: 'workingWeek',
        component: workingWeek,
        name: 'working Week',
        meta: {requiresAuth: true}
      },
      {
        path: 'leaveEntitlement',
        component: leaveEntitlement,
        name: 'leave Entitlement',
        meta: {requiresAuth: true}
      },
      {
        path: 'payHead',
        component: payHead,
        name: 'pay Head',
        meta: {requiresAuth: true}
      },
      {
        path: 'payGrade',
        component: payGrade,
        name: 'pay Grade',
        meta: {requiresAuth: true}
      },
      {
        path: 'employeePosition',
        component: employeePosition,
        name: 'Employee Position',
        meta: {requiresAuth: true}
      },
      {
        path: 'employeeSubGroup1',
        component: employeeSubGroup1,
        name: 'Employee SubGroup Child',
        meta: {requiresAuth: true}
      },
      {
        path: 'employeeGroup',
        component: employeeGroup,
        name: 'Employee Group',
        meta: {requiresAuth: true}
      },
      {
        path: 'addEmployee',
        component: addEmployee,
        name: 'Add Employee',
        meta: {requiresAuth: true}
      },
      {
        path: 'employee',
        component: employee,
        name: 'Employee',
        meta: {requiresAuth: true}
      },
      {
        path: 'employeeDetails',
        component: employeeDetails,
        name: 'employee Details',
        props: true
      },
      {
        path: 'leaveRequest',
        component: leaveRequest,
        name: 'leave request',
        props: true
      },
      {
        path: 'leaveReports',
        component: leaveReports,
        name: 'leave reports',
        props: true
      },
      {
        path: 'attendanceRequest',
        component: attendanceRequest,
        name: 'attendance Request',
        props: true
      },
      {
        path: 'attendanceRequestReport',
        component: attendanceRequestReport,
        name: 'Attendance Request Report',
        props: true
      },
      {
        path: 'salaryEntry',
        component: salaryEntry,
        name: 'Salary Entry',
        props: true
      },
      {
        path: 'salaryReport',
        component: salaryReport,
        name: 'Salary Report',
        props: true
      },
      {
        path: 'inventoryAssignEntry',
        component: InventoryAssignEntry,
        name: 'Inventory Assign Entry',
        props: true,
        meta: {requiresAuth: true}
      },
      {
        path: 'inventoryAssignReport',
        component: InventoryAssignReport,
        name: 'Inventory Assign Report',
        meta: { requiresAuth: true, keepAlive: true }
      },
      {
        path: 'assignDetails',
        component: assignDetails,
        name: 'assign Detail Report',
        props: true,
        meta: { requiresAuth: true }
      },
      {
        path: 'employeeTransfer',
        component: EmployeeTransfer,
        name: 'Employee Transfer',
        meta: { requiresAuth: true }
      },
      {
        path: 'profile',
        component: profile,
        name: 'Profile',
        meta: {requiresAuth: true}
      },
      // Analysis Reports
      {
        path: 'purchaseAnalysisProductWise',
        component: purchaseAnalysisProductWise,
        name: 'Purchase Analysis ProductWise',
        meta: {requiresAuth: true}
      },
      {
        path: 'salesAnalysisProductWise',
        component: salesAnalysisProductWise,
        name: 'Sales Analysis ProductWise',
        meta: {requiresAuth: true}
      },
      {
        path: 'purchaseAnalysisSupplierWise',
        component: purchaseAnalysisSupplierWise,
        name: 'Purchase Analysis Supplier Wise',
        meta: {requiresAuth: true}
      },
      {
        path: 'salesAnalysisCustomerWise',
        component: salesAnalysisCustomerWise,
        name: 'Sales Analysis Customer Wise',
        meta: {requiresAuth: true}
      },
      {
        path: 'purchaseAnalysisMonthlyProductWise',
        component: purchaseAnalysisMonthlyProductWise,
        name: 'Purchase Analysis Monthly ProductWise',
        meta: {requiresAuth: true}
      },
      {
        path: 'salesAnalysisMonthlyProductWise',
        component: salesAnalysisMonthlyProductWise,
        name: 'Sales Analysis Monthly ProductWise',
        meta: {requiresAuth: true}
      },
      {
        path: 'purchaseAnalysisMonthlySupplierWise',
        component: purchaseAnalysisMonthlySupplierWise,
        name: 'Purchase Analysis Monthly Supplier Wise',
        meta: {requiresAuth: true}
      },
      {
        path: 'salesAnalysisMonthlyCustomerWise',
        component: salesAnalysisMonthlyCustomerWise,
        name: 'Sales Analysis Monthly Customer Wise',
        meta: {requiresAuth: true}
      },
      {
        path: 'salesAnalysisMonthlyCustomerFiscalYearWise',
        component: salesAnalysisMonthlyCustomerFiscalYearWise,
        name: 'Sales Analysis Fiscal Year Monthly Customer Wise',
        meta: {requiresAuth: true}
      },
      {
        path: 'purchaseAnalysisQuarterlyProductWise',
        component: purchaseAnalysisQuarterlyProductWise,
        name: 'Purchase Analysis Quarterly ProductWise',
        meta: {requiresAuth: true}
      },
      {
        path: 'salesAnalysisQuarterlyProductWise',
        component: salesAnalysisQuarterlyProductWise,
        name: 'Sales Analysis Quarterly ProductWise',
        meta: {requiresAuth: true}
      },
      {
        path: 'purchaseAnalysisQuarterlySupplierWise',
        component: purchaseAnalysisQuarterlySupplierWise,
        name: 'Purchase Analysis Quarterly Supplier Wise',
        meta: {requiresAuth: true}
      },
      {
        path: 'salesAnalysisQuarterlyCustomerWise',
        component: salesAnalysisQuarterlyCustomerWise,
        name: 'Sales Analysis Quarterly Customer Wise',
        meta: {requiresAuth: true}
      },
      {
        path: 'profitAndLossAnalysisProductWise',
        component: profitAndLossAnalysisProductWise,
        name: 'Profit Loss Analysis Product Wise',
        meta: {requiresAuth: true}
      },
      {
        path: 'profitReportGross',
        component: profitReportGross,
        name: 'Profit Report Gross',
        meta: {requiresAuth: true}
      },
      {
        path: 'salesPaidCollectionReport',
        component: salesPaidCollectionReport,
        name: 'Sales Paid Collection Report',
        meta: {requiresAuth: true}
      },
      {
        path: 'monthlyDueAnalysisReport',
        component: monthlyDueAnalysisReport,
        name: 'Monthly Due Analysis Report',
        meta: {requiresAuth: true}
      },
      {
        path: 'expensesReport',
        component: expensesReport,
        name: 'Expenses Report',
        meta: {requiresAuth: true}
      },
      {
        path: 'profitAndLossAnalysis',
        component: profitAndLossAnalysis,
        name: 'Profit-Loss Customer Analysis',
        meta: {requiresAuth: true}
      },
      {
        path: 'categorySetup',
        component: categorySetup,
        name: 'Category Setup',
        meta: {requiresAuth: true}
      },
      {
        path: 'subCategorySetup',
        component: subCategorySetup,
        name: 'SubCategory Setup',
        meta: {requiresAuth: true}
      },
      {
        path: 'faItemMaster',
        component: faItemMaster,
        name: 'Fixed Assets ItemMaster',
        meta: {requiresAuth: true}
      },
      {
        path: 'poolConfiguration',
        component: poolConfiguration,
        name: 'FA Pool Type',
        meta: {requiresAuth: true}
      },
      {
        path: 'faExtraExpenses',
        component: faExtraExpenses,
        name: 'FA Extra Expenses',
        meta: {requiresAuth: true}
      },
      {
        path: 'faExtraExpensesItemwise',
        component: faExtraExpensesItemwise,
        name: 'FA Extra Expenses Itemwise',
        meta: {requiresAuth: true}
      },
      // {
      //   path: 'eventRegistration',
      //   component: eventRegistration,
      //   name: 'eventRegistration',
      //   meta: {requiresAuth: false}
      // },
      {
        path: 'eventReport',
        component: eventReport,
        name: 'eventReport',
        meta: {requiresAuth: true}
      },
      {
        path: 'manufacturer',
        component: manufacturer,
        name: 'manufacturer',
        meta: {requiresAuth: true}
      },
      {
        path: 'manufacturingOverhead',
        component: manufacturingOverhead,
        name: 'manufacturingOverhead',
        meta: {requiresAuth: true}
      },
      {
        path: 'manufacturingProductionReport',
        component: manufacturingProductionReport,
        name: 'manufacturingProductionReport',
        meta: {requiresAuth: true}
      },
      {
        path: 'batchSetup',
        component: batchSetup,
        name: 'batchSetup',
        meta: {requiresAuth: true}
      },
      {
        path: 'batchProcessSetup',
        component: batchProcessSetup,
        name: 'batchProcessSetup',
        meta: {requiresAuth: true}
      },
      {
        path: 'batchProcessFormulaSetup',
        component: batchProcessFormulaSetup,
        name: 'batchProcessFormulaSetup',
        meta: {requiresAuth: true}
      },
      {
        path: 'executeBatch',
        component: executeBatch,
        name: 'executeBatch',
        meta: {requiresAuth: true}
      },
      {
        path: 'processIssuedRaw',
        component: processIssuedRaw,
        name: 'processIssuedRaw',
        meta: {requiresAuth: true}
      },
      {
        path: 'stockJournalEntry',
        component: stockJournalEntry,
        name: 'stockJournalEntry',
        meta: {requiresAuth: true}
      },
      {
        path: 'blendReport',
        component: blendReport,
        name: 'blendReport',
        meta: {requiresAuth: true}
      },
      {
        path: 'compileReport',
        component: compileReport,
        name: 'compileReport',
        meta: {requiresAuth: true}
      },
      {
        path: 'dailyPurchaseReport',
        component: dailyPurchaseReport,
        name: 'dailyPurchaseReport',
        meta: {requiresAuth: true}
      },
      {
        path: 'packingReport',
        component: packingReport,
        name: 'packingReport',
        meta: {requiresAuth: true}
      },
      {
        path: 'stockJournalReport',
        component: stockJournalReport,
        name: 'stockJournalReport',
        meta: {requiresAuth: true}
      },
      {
        path: 'batchExecutedReport',
        component: batchExecutedReport,
        name: 'batchExecutedReport',
        meta: {requiresAuth: true}
      },
      {
        path: 'itemIssueReport',
        component: itemIssueReport,
        name: 'itemIssueReport',
        meta: {requiresAuth: true}
      },
      // CRM
      {
        path: 'crmClientDetails',
        component: crmClientDetails,
        name: 'Client Details',
        meta: {requiresAuth: true}
      },
      {
        path: 'crmCustomer',
        component: crmCustomer,
        name: 'Crm Customer',
        meta: {requiresAuth: true}
      },
      {
        path: 'crmCompanies',
        component: crmCompanies,
        name: 'Companies',
        meta: {requiresAuth: true}
      },
      {
        path: 'crmDealDetails',
        component: crmDealDetails,
        name: 'Deals',
        meta: {requiresAuth: true}
      },
      {
        path: 'crmProductDetails',
        component: crmProductDetails,
        name: 'Product Details',
        meta: {requiresAuth: true}
      },
      {
        path: 'crmTaskDetails',
        component: crmTaskDetails,
        name: 'Task Details',
        meta: {requiresAuth: true}
      },
      {
        path: 'crmTicketDetails',
        component: crmTicketDetails,
        name: 'Ticket Details',
        meta: {requiresAuth: true}
      },
      {
        path: 'crmFollowUpDetails',
        component: crmFollowUpDetails,
        name: 'Crm FollowUp Details',
        meta: {requiresAuth: true}
      },
      {
        path: 'crmAllFollowUpDetails',
        component: crmAllFollowUpDetails,
        name: 'Crm All FollowUp Details',
        meta: {requiresAuth: true}
      },
      {
        path: 'crmMasterSetup',
        component: crmMasterSetup,
        name: 'Crm Master Setup',
        meta: {requiresAuth: true}
      },
      {
        path: 'crmCustomerWiseReport',
        component: crmCustomerWiseReport,
        name: 'Customer Wise Next Follow Up',
        meta: {requiresAuth: true}
      },
      {
        path: 'crmTodayFollowUp',
        component: crmTodayFollowUp,
        name: 'Today FollowUp (To Do)',
        meta: {requiresAuth: true}
      },
      {
        path: 'crmStageWiseGraph',
        component: crmStageWiseGraph,
        name: 'CRM Stage Wise Graph',
        meta: {requiresAuth: true}
      },
      {
        path: 'crmUserWiseGraph',
        component: crmUserWiseGraph,
        name: 'CRM User Wise Graph',
        meta: {requiresAuth: true}
      },
      {
        path: 'crmUserWiseMonthlyGraph',
        component: crmUserWiseMonthlyGraph,
        name: 'CRM User Wise Monthly Graph',
        meta: {requiresAuth: true}
      },
      {
        path: 'crmTotalTodayFollowUp',
        component: crmTotalTodayFollowUp,
        name: 'Total Todays FollowUp (Done)',
        meta: {requiresAuth: true}
      },
      {
        path: 'crmNotReceivedCalls',
        component: crmNotReceivedCalls,
        name: 'Call Not Received Report',
        meta: {requiresAuth: true}
      },
      {
        path: 'crmFollowUpDateRange',
        component: crmFollowUpDateRange,
        name: 'Follow Up Between Date',
        meta: {requiresAuth: true}
      },
      {
        path: 'quotationSent',
        component: quotationSent,
        name: 'Quotation Sent',
        meta: {requiresAuth: true}
      },
      {
        path: 'sampleSent',
        component: sampleSent,
        name: 'Sample Sent',
        meta: {requiresAuth: true}
      },
      {
        path: 'crmVIsitorDetails',
        component: crmVIsitorDetails,
        name: 'Visitor Details',
        meta: {requiresAuth: true}
      },
      // Fiiscal Year Settlement
      {
        path: 'fiscalYearSettlement',
        component: fiscalYearSettlement,
        name: 'Fiscal Year Settlement',
        meta: {requiresAuth: true}
      },
      {
        path: 'fiscalYearSettledReport',
        component: fiscalYearSettledReport,
        name: 'Fiscal Year Settled Report',
        meta: {requiresAuth: true}
      },
      {
        path: 'balanceBroughtDown',
        component: balanceBroughtDown,
        name: 'Balance Broughtdown',
        meta: {requiresAuth: true}
      },
      {
        path: 'itemBroughtDownStoreWise',
        component: itemBroughtDownStoreWise,
        name: 'Update Item Balance Brought Down',
        meta: {requiresAuth: true}
      },
      {
        path: 'balanceCarryOverReport',
        component: balanceCarryOverReport,
        name: 'Balance CarryOver Report',
        meta: {requiresAuth: true}
      },
      // NOC POS nocPosSales
      {
        path: 'nocPosSales',
        component: nocPosSales,
        name: 'Noc Pos Sales',
        meta: {requiresAuth: true}
      },
      {
        path: 'excelUpload',
        component: excelUpload,
        name: 'Excel Upload',
        meta: {requiresAuth: true}
      },
      {
        path: 'purchaseSalesGraph',
        component: PurchaseSalesGraph,
        name: 'Purchase Sales Graph View',
        meta: {requiresAuth: true}
      },
      {
        path: 'salesTragetGraph',
        component: SalesTragetGraph,
        name: 'Sales Target Graph View',
        meta: {requiresAuth: true}
      },
      {
        path: 'itemSalesMonthlyGraph',
        component: ItemSalesMonthlyGraph,
        name: 'Monthly Sales Item Wise Graph View',
        meta: {requiresAuth: true}
      },
      {
        path: 'receiptPaymentGraph',
        component: ReceiptPaymentGraph,
        name: 'Receipt Payment Graph View',
        meta: {requiresAuth: true}
      },
      {
        path: 'WeeklySalesReportGraph',
        component: WeeklySalesReportGraph,
        name: 'Weekly Sales Report Graph',
        meta: {requiresAuth: true}
      },
      {
        path: 'ItemWiseProfitLossAnalysisGraph',
        component: ItemWiseProfitLossAnalysisGraph,
        name: 'Item Wise Profit Loss Analysis Graph',
        meta: {requiresAuth: true}
      },
      {
        path: 'salesPaidCashCollectionGraph',
        component: salesPaidCashCollectionGraph,
        name: 'Sales Payment Collection Graph',
        meta: {requiresAuth: true}
      },
      {
        path: 'DailySalesReportGraph',
        component: DailySalesReportGraph,
        name: 'Daily Sales Report Graph',
        meta: {requiresAuth: true}
      },
      {
        path: 'CustomerWiseSalesCountGraph',
        component: CustomerWiseSalesCountGraph,
        name: 'Customer Wise Sales Count Graph',
        meta: {requiresAuth: true}
      },
      {
        path: 'UserWiseSalesGraph',
        component: UserWiseSalesCounntGraph,
        name: 'User Wise Sales Count Graph',
        meta: {requiresAuth: true}
      },
      {
        path: 'GrossMarginGraph',
        component: GrossMarginGraph,
        name: 'Gross Margin Graph',
        meta: {requiresAuth: true}
      },
      {
        path: 'DueAnalysisGraph',
        component: DueAnalysisGraph,
        name: 'Monthly Due Analysis Graph',
        meta: {requiresAuth: true}
      }

    ]
  }, {
    // not found handler
    path: '/**',
    component: NotFoundView
  }
]

export default routes



// WEBPACK FOOTER //
// ./src/routes.js